import { render } from "./FullTestComponent.vue?vue&type=template&id=c3e064d4&scoped=true"
import script from "./FullTestComponent.vue?vue&type=script&lang=js"
export * from "./FullTestComponent.vue?vue&type=script&lang=js"

import "./FullTestComponent.vue?vue&type=style&index=0&id=c3e064d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e064d4"]])

export default __exports__